<svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.5 14V7H3.5V14C3.5 14.5523 3.94772 15 4.5 15H12.5C13.0523 15 13.5 14.5523 13.5 14Z" />
  <path
    d="M9.5 3V4H11.5V3C11.5 1.34314 10.1569 -1.19209e-07 8.5 0C6.84315 1.19209e-07 5.5 1.34315 5.5 3V4L7.5 4L7.5 3C7.5 2.44772 7.94772 2 8.5 2C9.05228 2 9.5 2.44772 9.5 3Z"
  />
  <path
    d="M1.5 5C1.5 5.55229 1.94772 6 2.5 6H14.5C15.0523 6 15.5 5.55229 15.5 5C15.5 4.44772 15.0523 4 14.5 4H2.5C1.94772 4 1.5 4.44772 1.5 5Z"
  />
</svg>
